import AssistantCitation from "ai-assistant/values/assistant-citation";
import Guid from "common/values/guid/guid";

export default class AssistantCitationAPIResponse {
  public fileId?: string;
  public fileName?: string;
  public page?: number;
  public nodeId?: string;
  public score?: number;
  public semanticScore?: number;
  public combinedScore?: number;
  public matched?: boolean;
  public text?: string;

  public deserialize(): AssistantCitation {
    if (!this.fileId) {
      throw new Error("Invalid AssistantCitationAPIResponse: fileId must be defined");
    }
    if (!this.fileName) {
      throw new Error("Invalid AssistantCitationAPIResponse: fileName must be defined");
    }

    return new AssistantCitation(
      Guid.fromJSON(this.fileId),
      this.fileName,
      this.page,
      this.nodeId ? Guid.fromJSON(this.nodeId) : undefined,
      this.score,
      this.semanticScore,
      this.combinedScore,
      this.matched,
      this.text
    );
  }
}
